var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#E2598B",
    fillOpacity: 0.05
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1284_89)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.35 30.04C39.0141 28.3377 38.0976 26.8049 36.7571 25.7032C35.4165 24.6016 33.7351 23.9996 32 24C29.11 24 26.6 25.64 25.35 28.04C23.8802 28.1988 22.521 28.8952 21.5335 29.9953C20.546 31.0954 19.9998 32.5217 20 34C20 37.31 22.69 40 26 40H39C41.76 40 44 37.76 44 35C44 32.36 41.95 30.22 39.35 30.04ZM39 38H26C23.79 38 22 36.21 22 34C22 31.79 23.79 30 26 30H26.71C27.37 27.69 29.48 26 32 26C35.04 26 37.5 28.46 37.5 31.5V32H39C40.66 32 42 33.34 42 35C42 36.66 40.66 38 39 38Z",
    fill: "#E2598B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1284_89"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(20 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.9c92fc72a54400be17ff376ea312f5de.svg";
export { ForwardRef as ReactComponent };